import { useQuery } from "@tanstack/react-query";
import { getTransactionFeesEarnings } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const TRANSACTIONS_FEES_ADMIN_MOONE_EARNINGS_QUERY_KEY =
  "TRANSACTIONS_FEES_ADMIN_MOONE_EARNINGS";

export const getTransactionsFeesAdminMooneEarningsQueryKey = (
  dateFrom?: string | null,
  dateTo?: string | null,
) => [TRANSACTIONS_FEES_ADMIN_MOONE_EARNINGS_QUERY_KEY, dateFrom, dateTo];

export const useTransactionsFeesAdminMooneEarnings = (
  dateFrom?: string | null,
  dateTo?: string | null,
) =>
  useQuery({
    queryKey: getTransactionsFeesAdminMooneEarningsQueryKey(dateFrom, dateTo),
    queryFn: processResponseWithApiProblemDetails(() =>
      getTransactionFeesEarnings(dateFrom, dateTo),
    ),
  });
